import { useEffect, useState, useRef } from "react";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, orderBy, query } from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";



import "./index.css";
import MapaEditor from "./MapaEditor";

function Mapa() {
  const [maps, setMaps] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ title: "", image: "", expo_map: false });
  const [isEditing, setIsEditing] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileRef = useRef(null);

  useEffect(() => {
    const fetchMaps = async () => {
      const q = query(collection(db, "evento_mapas"), orderBy("titulo", "asc"));
      const snap = await getDocs(q);
      const loaded = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setMaps(loaded);
    };
    fetchMaps();
  }, []);

  const addMap = () => {
    const newItem = { id: "temp-" + Date.now(), title: "", image: "", expo_map: false };
    setMaps((prev) => [newItem, ...prev]);
    setSelected(newItem);
    setIsEditing(true);
    setForm(newItem);
    setImagePreview(null);
  };

  const saveMap = async () => {
    let id = selected.id;
    const data = {
      titulo: form.title,
      mapa: form.image || selected.mapa,
      mapa_dos_expositores: form.expo_map,
    };

    if (id.startsWith("temp-")) {
      const docRef = await addDoc(collection(db, "evento_mapas"), data);
      id = docRef.id;
    } else {
      await updateDoc(doc(db, "evento_mapas", id), data);
    }

    setMaps((prev) => prev.map((m) => (m.id === selected.id ? { ...m, id, ...data } : m)));
    setSelected({ id, ...data });
    setIsEditing(false);
    setImagePreview(null);
  };

  const deleteMap = async (id) => {
    if (!window.confirm("Tem certeza de que deseja excluir este mapa da app?")) return;
    await deleteDoc(doc(db, "evento_mapas", id));
    setMaps((prev) => prev.filter((m) => m.id !== id));
    if (selected?.id === id) setSelected(null);
  };

  return (
    <div className="table-container">
      <div className="filtros">
        <button className="btn btn-add" onClick={addMap}>
           Novo Mapa
        </button>
      </div>

      {maps.length === 0 ? (
        <p style={{ textAlign: "center", color: "#292f2c" }}>Sem dados</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Imagem</th>
              <th>Título</th>
              <th>Mapa dos Expositores</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {maps.map((m) => (
              <tr key={m.id}>
                <td>{m.mapa ? <img src={m.mapa} alt="" style={{ width: 80 }} /> : "—"}</td>
                <td>{m.titulo || "—"}</td>
                <td>{m.mapa_dos_expositores ? "Sim" : "Não"}</td>
                <td>
                  <button
                    className="btn btn-add"
                    onClick={() => {
                      setSelected(m);
                      setForm({
                        title: m.titulo,
                        image: m.mapa,
                        expo_map: m.mapa_dos_expositores,
                      });
                      setIsEditing(false);
                      setImagePreview(null);
                    }}
                  >
                     Editar
                  </button>
                  <button className="btn btn-delete" onClick={() => deleteMap(m.id)}>
                     Apagar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selected && (
        <div className="drawer">
          {isEditing ? (
            <div className="drawer-content">
              <label>Título:</label>
              <input
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
              />

              <br />
              <br />

              <label>Imagem:</label>
              <input
                type="file"
                ref={fileRef}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const imgRef = ref(storage, `mapas/${file.name}`);
                  await uploadBytes(imgRef, file);
                  const url = await getDownloadURL(imgRef);
                  setForm((prev) => ({ ...prev, image: url }));
                  setImagePreview(URL.createObjectURL(file));
                }}
              />

              {(imagePreview || form.image) && (
                <img src={imagePreview || form.image} alt="Preview" style={{ width: 200, marginTop: 10 }} />
              )}

              <br />
              <br />

              <label>
                Mapa dos Expositores:
                <input
                  type="checkbox"
                  checked={form.expo_map}
                  onChange={(e) => setForm((prev) => ({ ...prev, expo_map: e.target.checked }))}
                />
              </label>

              <div className="drawer-footer">
                <button className="btn btn-add" onClick={saveMap}>
                  Guardar
                </button>
              </div>
            </div>
          ) : (
            <div className="drawer-content">
              <h3>{selected.titulo}</h3>
              {selected.mapa && <MapaEditor mapa={selected} />}
              <div className="drawer-footer">
                <button className="btn btn-add" onClick={() => setIsEditing(true)}>
                   Editar
                </button>
               <button className="btn btn-cancel" onClick={() => setSelected(null)}>
                  Fechar
               </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Mapa;
